import { injectable } from "inversify";
import ValidationResult from "./ValidationResult";
import {BaseValidator} from "./BaseValidator";

@injectable()
export class EmptyValidator extends BaseValidator<any> {
    public Validate(entity: any): ValidationResult {
        return ValidationResult.Success();
    }
}